import styled from "@emotion/styled";

export const TimelineScroll = styled.div(({ theme, $variant }) => {
  const isDocument = $variant === "report" || $variant === "document";

  return `
  min-height: ${isDocument ? "auto" : "0"};
  height: ${isDocument ? "auto" : "100%"};
  max-height: ${isDocument ? "none" : "100%"};
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.5rem;
  padding: 0.6rem 0.65rem 0.8rem 0.65rem;
  overscroll-behavior: ${isDocument ? "auto" : "contain"};
  overflow-x: hidden;
  overflow-y: ${isDocument ? "visible" : "scroll"};
  scrollbar-gutter: ${isDocument ? "auto" : "stable"};
  background: ${theme.palette.common.cardBackground};

  ::-webkit-scrollbar-thumb {
    ${isDocument ? "display: none;" : `
      border: 0.1rem solid ${theme.palette.common.grayText};
      background-color: ${theme.palette.common.grayText};
    `}
  }

  ::-webkit-scrollbar {
    ${isDocument ? "display: none;" : `
      -webkit-appearance: none;
      border: 0.05rem solid ${theme.palette.common.grayBorderDark};
      background-color: ${theme.palette.common.pageBackground};
    `}
  }

  ::-webkit-scrollbar:vertical {
    width: ${isDocument ? "0" : "0.4rem"};
  }
`
})

export const TimelineEvent = styled.div`
  flex: 0 0 auto;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 0;

  &.first {
    padding-top: 0.15rem;
  }
`

export const TimelineCard = styled.article(({ theme }) => `
  width: 100%;
  height: auto;
  max-width: 100%;
  min-width: 0;
  min-height: 0;
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: 2.2rem minmax(0, 1fr);
  align-items: stretch;
  border: 0.1rem solid ${theme.palette.common.grayBorder};
  border-radius: 0.75rem;
  background: ${theme.palette.common.white};
  box-shadow: 0 0.2rem 0.8rem rgba(15, 23, 42, 0.06);
  overflow: hidden;

  > div:last-child {
    min-width: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    min-height: 0 !important;
    padding: 0.82rem 0.82rem 1rem !important;
    background: ${theme.palette.common.white} !important;
    overflow: hidden;
    overflow-wrap: anywhere;
  }

  > div:last-child > div:first-of-type {
    align-items: flex-start;
    gap: 0.5rem;
    margin-top: 0 !important;
    padding: 0.12rem 0 0.62rem;
    border-bottom: 0.1rem solid ${theme.palette.common.grayBorder};
  }

  > div:last-child,
  > div:last-child * {
    min-width: 0 !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }

  > div:last-child [style*="width:"] {
    width: auto !important;
  }

  > div:last-child [style*="min-width:"] {
    min-width: 0 !important;
  }

  > div:last-child [style*="max-width:"] {
    max-width: 100% !important;
  }

  > div:last-child [style*="margin-left"] {
    margin-left: 0 !important;
  }

  > div:last-child [style*="padding-left"] {
    padding-left: 0 !important;
  }

  > div:last-child [style*="margin: 0.5rem 0 1rem"],
  > div:last-child [style*="margin: 0.5rem 0px 1rem"] {
    margin: 0.45rem 0 0 !important;
  }

  > div:last-child [style*="margin: 1rem 0"],
  > div:last-child [style*="margin: 1rem 0px"] {
    margin: 0.55rem 0 0.35rem !important;
  }

  > div:last-child .fitContentHeight,
  > div:last-child .fitContentWidth {
    width: 100% !important;
    min-width: 0 !important;
    height: auto !important;
    min-height: 0 !important;
  }

  > div:last-child .column {
    width: 100% !important;
    min-width: 0 !important;
  }

  > div:last-child > div:not(:first-of-type),
  > div:last-child > div:not(:first-of-type) > div {
    flex-wrap: wrap;
  }

  > div:last-child p,
  > div:last-child span,
  > div:last-child div {
    white-space: normal;
    overflow-wrap: anywhere;
  }

  > div:last-child .noTextWrap {
    text-wrap: wrap;
    white-space: normal;
  }

  > div:last-child .justifyEnd {
    justify-content: flex-start;
    text-align: left;
  }

  > div:last-child .xLarge,
  > div:last-child .xLargeHeight {
    font-size: 1rem;
    line-height: 1.25;
  }

  > div:last-child .largeHeight {
    font-size: 0.9rem;
    line-height: 1.25;
  }

  > div:last-child .timelineDetail,
  > div:last-child .timelineItem,
  > div:last-child .wrapped,
  > div:last-child .wrappedRed,
  > div:last-child .wrappedGray {
    width: fit-content !important;
    max-width: 100% !important;
    white-space: normal;
  }

  > div:last-child .timeline,
  > div:last-child [class*="timeline"] {
    max-width: 100% !important;
  }

  > div:last-child [tabindex="-1"] {
    max-width: 100% !important;
    white-space: normal;
  }

  > div:last-child [tabindex="-1"] > div {
    min-width: 0 !important;
    overflow-wrap: anywhere;
  }

  > div:last-child [style*="height: 2.5rem"],
  > div:last-child [style*="height: 5rem"],
  > div:last-child [style*="height: 15.6rem"] {
    height: auto !important;
    min-height: 0 !important;
  }

  > div:last-child [style*="padding-right"] {
    padding-right: 0 !important;
  }

  > div:last-child .thin {
    display: inline;
  }

  > div:last-child svg {
    flex: 0 0 auto;
  }

  .milestone {
    box-shadow: none;
    border: 0.1rem solid ${theme.palette.primary.main};
    background: ${theme.palette.primary.labelTransparent};
    color: ${theme.palette.primary.dark};
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
  }
`)

export const TimelineContent = styled.section(({ theme }) => `
  width: 100%;
  min-width: 0;
  max-width: 100%;
  display: grid;
  gap: 0.52rem;
  padding-bottom: 0.8rem;
  padding-right: 0.6rem;
  background: ${theme.palette.common.white};
  color: ${theme.palette.common.black};
  overflow-wrap: anywhere;
`)

export const TimelineTitleRow = styled.div(({ theme }) => `
  width: 100%;
  min-width: 0;
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  padding: 0.5rem 0.8rem 0.4rem 0.62rem;
  border-bottom: 0.1rem solid ${theme.palette.common.grayBorder};
`)

export const TimelineTitle = styled.div(({ theme }) => `
  min-width: 0;
  flex: 1 1 auto;
  color: ${theme.palette.common.black};
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1.32;
  overflow-wrap: anywhere;
  margin-top: 0.1rem;
`)

export const TimelineNewBadge = styled.div(({ theme }) => `
  flex: 0 0 auto;
  width: fit-content;
  margin-top: 0.03rem;
  padding: 0.16rem 0.48rem;
  border: 0.1rem solid ${theme.palette.primary.main};
  border-radius: 999rem;
  background: ${theme.palette.primary.labelTransparent};
  color: ${theme.palette.primary.dark};
  font-size: 0.68rem;
  font-weight: 700;
  line-height: 1.1;
  text-transform: uppercase;
`)

export const TimelineMetaList = styled.div`
  width: 100%;
  min-width: 0;
  display: grid;
  gap: 0.25rem;
`

export const TimelineMetaRow = styled.div(({ theme }) => `
  width: 100%;
  min-width: 0;
  display: flex;
  align-items: baseline;
  gap: 0.32rem;
  color: ${theme.palette.common.black};
  font-size: 0.82rem;
  line-height: 1.32;

  .timeline-meta-label {
    flex: 0 0 auto;
    color: ${theme.palette.common.grayText};
    font-weight: 600;
    text-transform: lowercase;
  }

  .timeline-meta-value {
    min-width: 0;
    flex: 1 1 auto;
    font-weight: 500;
    overflow-wrap: anywhere;
  }
`)

export const TimelineSection = styled.section(({ theme }) => `
  width: 100%;
  min-width: 0;
  display: grid;
  gap: 0.38rem;
  padding-top: 0.38rem;
  border-top: 0.1rem solid ${theme.palette.common.grayBorder};
`)

export const TimelineSectionTitle = styled.div(({ theme }) => `
  color: ${theme.palette.common.grayText};
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1.25;
  text-transform: uppercase;
`)

export const TimelineTagList = styled.div`
  width: 100%;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
`

export const TimelineTagPill = styled.div(({ theme }) => `
  min-width: 0;
  max-width: 100%;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.22rem 0.42rem;
  border: 0.1rem solid ${theme.palette.common.grayBorder};
  border-radius: 999rem;
  background: ${theme.palette.common.cardBackground};
  color: ${theme.palette.common.black};
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.25;
  overflow-wrap: anywhere;

  &.tier-one {
    border-color: rgba(185, 28, 28, 0.28);
    background: rgba(185, 28, 28, 0.08);
    color: #7f1d1d;
  }

  &.tier-two {
    border-color: rgba(109, 40, 217, 0.28);
    background: rgba(109, 40, 217, 0.08);
    color: #4c1d95;
  }

  &.tier-three,
  &.success {
    border-color: ${theme.palette.primary.main};
    background: ${theme.palette.primary.labelTransparent};
    color: ${theme.palette.primary.dark};
  }
`)

export const TimelineChangeList = styled.div`
  width: 100%;
  min-width: 0;
  display: grid;
  gap: 0.32rem;
`

export const TimelineChangeRow = styled.div(({ theme }) => `
  width: 100%;
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(5.5rem, 7rem) minmax(0, 1fr);
  gap: 0.35rem;
  align-items: start;
  color: ${theme.palette.common.black};
  font-size: 0.8rem;
  line-height: 1.32;

  .timeline-change-label {
    min-width: 0;
    color: ${theme.palette.common.grayText};
    font-weight: 600;
    overflow-wrap: anywhere;
  }

  .timeline-change-value {
    min-width: 0;
    font-weight: 600;
    overflow-wrap: anywhere;
  }

  .timeline-change-delta {
    width: fit-content;
    max-width: 100%;
    margin-top: 0.2rem;
  }
`)

export const TimelineCallout = styled.div(({ theme }) => `
  width: 100%;
  min-width: 0;
  display: flex;
  align-items: stretch;
  overflow: hidden;
  border: 0.1rem solid ${theme.palette.common.grayBorder};
  border-radius: 0.7rem;
  background: ${theme.palette.common.cardBackground};
  color: ${theme.palette.common.grayDark};

  .timeline-callout-icon {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    background: ${theme.palette.common.grayText};
    color: ${theme.palette.common.white};
  }

  .timeline-callout-copy {
    min-width: 0;
    padding: 0.55rem 0.65rem;
    font-size: 0.8rem;
    font-weight: 500;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }
`)
